export const MODAL_ROOT_ID = 'modal-root';
export const TOAST_ROOT_ID = 'toast-root';

export const DIALOG_LAYER_TYPE = Symbol('dialog');
